/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useAuth0 } from "@auth0/auth0-react";
import { ToastContainer } from "react-toastify";
import { LoaderWrap } from "~/components";
import { BillingPeriodBar } from "~/layout";
import { GlobalSwitch } from "~/routing";
import { useCustomers } from "~/services/customers";
import { useSetupUserTracking } from "~/services/tracking";

export function App() {
  const { isLoading, user } = useAuth0();
  const { selectedCustomer } = useCustomers();
  useSetupUserTracking({ ...user, selectedCustomer });

  return (
    <LoaderWrap loading={isLoading}>
      <div css={{ flex: "1 0 auto" }}>
        <BillingPeriodBar />
        <ToastContainer />
        <GlobalSwitch />
      </div>
    </LoaderWrap>
  );
}
